import { z } from "zod";
import { BUDGET_NAME, NOTES, VERSION_NO, YEAR } from "./consts";

export const schema = z.object({
  [BUDGET_NAME]: z
    .string()
    .min(3, "Minimum 3 characters are required for this field"),
  [VERSION_NO]: z.string().min(1, "This field is required"),
  [YEAR]: z.string().min(1, "This field is required"),
  [NOTES]: z.string().optional(),
});

export type formValues = z.infer<typeof schema>;
